import { useDomainText } from '@/composables/text/useDomainText';

const { t } = useDomainText('customers');

export const CUSTOMER_DETAIL_TABS = Object.freeze([
  { key: 'summary', label: t('detail.tabs.summary', 'Resumen') },
  { key: 'information', label: t('detail.tabs.information', 'Información') },
  { key: 'business', label: t('detail.tabs.business', 'Negocios') },
  { key: 'finance', label: t('detail.tabs.finance', 'Finanzas') },
  { key: 'analysis', label: t('detail.tabs.analysis', 'Análisis') },
  { key: 'documents', label: t('detail.tabs.documents', 'Documentos') },
  { key: 'settings', label: t('detail.tabs.settings', 'Opciones avanzadas') },
  { key: 'history', label: t('detail.tabs.history', 'Historial') },
]);
